export type ShowcaseCategory = "All" | "Cards" | "Sneakers" | "Tech" | "Games" | "Clothing" | "Computers";

export interface ShowcaseListing {
  id: string;
  title: string;
  category: Exclude<ShowcaseCategory, "All">;
  seller: { name: string; initial: string; color: string };
  buyPrice: number;
  sellPrice: number;
  condition: string;
  image: string;
  interestedCount: number;
  timeAgo: string;
  description: string;
}

export const CATEGORIES: ShowcaseCategory[] = ["All", "Cards", "Sneakers", "Tech", "Games", "Clothing", "Computers"];

export const SHOWCASE_LISTINGS: ShowcaseListing[] = [
  {
    id: "card-1",
    title: "Charizard VMAX Rainbow Rare",
    category: "Cards",
    seller: { name: "FlipKing_Alex", initial: "A", color: "bg-amber-500" },
    buyPrice: 180, sellPrice: 340, condition: "PSA 10",
    image: "https://public.readdy.ai/ai/img_res/ea97ec27233fd32c95ae4f23d7e075ea.jpg",
    interestedCount: 14, timeAgo: "2h ago",
    description: "Pulled from a booster box, sent to PSA — came back a perfect 10. Rare opportunity.",
  },
  {
    id: "card-2",
    title: "LeBron James Rookie PSA 10",
    category: "Cards",
    seller: { name: "SportFlip_Mo", initial: "M", color: "bg-rose-500" },
    buyPrice: 420, sellPrice: 890, condition: "PSA 10",
    image: "https://readdy.ai/api/search-image?query=LeBron%20James%20NBA%20rookie%20basketball%20trading%20card%20graded%20PSA%2010%20slab%20displayed%20upright%20on%20dark%20surface%2C%20premium%20sports%20card%20collectibles%20product%20photography%2C%20professional%20studio%20lighting%2C%20clean%20dark%20minimal%20background%20with%20subtle%20glow%20effect&width=480&height=320&seq=sc-card-2&orientation=landscape",
    interestedCount: 31, timeAgo: "5h ago",
    description: "2003 Topps Chrome rookie in a PSA 10. Graded investment piece, rarely available.",
  },
  {
    id: "card-3",
    title: "Pokémon Base Set Booster Box",
    category: "Cards",
    seller: { name: "VaultFlips", initial: "V", color: "bg-violet-500" },
    buyPrice: 350, sellPrice: 650, condition: "Sealed",
    image: "https://readdy.ai/api/search-image?query=sealed%20pokemon%20trading%20card%20game%20original%20base%20set%20booster%20box%20stack%20on%20clean%20white%20marble%20surface%2C%20collectible%20card%20product%20photography%2C%20soft%20studio%20lighting%2C%20minimal%20clean%20background%2C%20crisp%20vintage%20packaging%20detail%20visible&width=480&height=320&seq=sc-card-3&orientation=landscape",
    interestedCount: 22, timeAgo: "1d ago",
    description: "Unopened 1999 booster box. Storage find — prices only go up from here.",
  },
  {
    id: "shoe-1",
    title: "Jordan 1 High OG Chicago 2022",
    category: "Sneakers",
    seller: { name: "SoleSeller_Jake", initial: "J", color: "bg-red-500" },
    buyPrice: 170, sellPrice: 420, condition: "DS",
    image: "https://readdy.ai/api/search-image?query=Nike%20Air%20Jordan%201%20High%20OG%20Chicago%20red%20white%20black%20colorway%20deadstock%20sneakers%20floating%20against%20pure%20white%20background%2C%20premium%20sneaker%20product%20photography%2C%20professional%20studio%20lighting%2C%20clean%20minimal%20setting%20showing%20both%20shoes%20from%20side%20profile%20angle&width=480&height=320&seq=sc-shoe-1&orientation=landscape",
    interestedCount: 47, timeAgo: "3h ago",
    description: "Size 10. Deadstock. OG box and all accessories. 147% profit margins speak for themselves.",
  },
  {
    id: "shoe-2",
    title: "Yeezy Boost 350 V2 Zebra",
    category: "Sneakers",
    seller: { name: "BoostBoss", initial: "B", color: "bg-emerald-500" },
    buyPrice: 220, sellPrice: 380, condition: "DS",
    image: "https://readdy.ai/api/search-image?query=Adidas%20Yeezy%20Boost%20350%20V2%20Zebra%20white%20black%20stripe%20knit%20pattern%20sneaker%20pair%20on%20clean%20white%20background%2C%20premium%20footwear%20collectible%20product%20photography%2C%20professional%20studio%20lighting%2C%20minimal%20clean%20surface%2C%20both%20shoes%20displayed%20from%20side%20angle&width=480&height=320&seq=sc-shoe-2&orientation=landscape",
    interestedCount: 19, timeAgo: "6h ago",
    description: "Size 11 DS. Copped retail, never worn. Clean profit in 3 days.",
  },
  {
    id: "shoe-3",
    title: "Nike Dunk Low Panda",
    category: "Sneakers",
    seller: { name: "DunkDepot", initial: "D", color: "bg-sky-500" },
    buyPrice: 110, sellPrice: 225, condition: "DS",
    image: "https://readdy.ai/api/search-image?query=Nike%20Dunk%20Low%20Panda%20black%20white%20colorway%20deadstock%20sneakers%20pair%20on%20clean%20white%20background%2C%20premium%20sneaker%20photography%2C%20professional%20studio%20lighting%2C%20minimal%20clean%20setting%20both%20shoes%20visible%20from%20front%20angle%2C%20crisp%20product%20shot&width=480&height=320&seq=sc-shoe-3&orientation=landscape",
    interestedCount: 28, timeAgo: "12h ago",
    description: "Size 9. The classic Panda colourway. Always in demand, always a profit.",
  },
  {
    id: "tech-1",
    title: "RTX 4090 Founders Edition",
    category: "Tech",
    seller: { name: "PCPartsKing", initial: "P", color: "bg-teal-500" },
    buyPrice: 1200, sellPrice: 1850, condition: "Sealed",
    image: "https://readdy.ai/api/search-image?query=NVIDIA%20GeForce%20RTX%204090%20Founders%20Edition%20graphics%20card%20GPU%20sealed%20box%20on%20clean%20dark%20minimal%20background%2C%20premium%20high-end%20PC%20hardware%20product%20photography%2C%20dramatic%20studio%20lighting%20highlighting%20the%20large%20GPU%20box%20packaging%20with%20NVIDIA%20branding&width=480&height=320&seq=sc-tech-1&orientation=landscape",
    interestedCount: 38, timeAgo: "4h ago",
    description: "Factory sealed. Copped during a restock alert. GPU demand is relentless.",
  },
  {
    id: "tech-2",
    title: "iPhone 15 Pro Max 256GB",
    category: "Tech",
    seller: { name: "AppleFlips", initial: "A", color: "bg-orange-500" },
    buyPrice: 999, sellPrice: 1220, condition: "Sealed",
    image: "https://readdy.ai/api/search-image?query=Apple%20iPhone%2015%20Pro%20Max%20natural%20titanium%20in%20original%20sealed%20retail%20box%20packaging%20on%20clean%20white%20surface%2C%20premium%20smartphone%20electronics%20product%20photography%2C%20minimal%20studio%20lighting%2C%20pristine%20white%20background%2C%20box%20detail%20crisp&width=480&height=320&seq=sc-tech-2&orientation=landscape",
    interestedCount: 17, timeAgo: "8h ago",
    description: "Titanium. Unopened. Local buyers lined up for these during launch week.",
  },
  {
    id: "tech-3",
    title: "DJI Mini 4 Pro Combo",
    category: "Tech",
    seller: { name: "DJI_Dave", initial: "D", color: "bg-pink-500" },
    buyPrice: 760, sellPrice: 1050, condition: "New",
    image: "https://readdy.ai/api/search-image?query=DJI%20Mini%204%20Pro%20drone%20with%20RC2%20controller%20and%20carrying%20case%20open%20on%20clean%20white%20background%2C%20premium%20compact%20drone%20tech%20gadget%20product%20photography%2C%20professional%20studio%20lighting%2C%20clean%20minimal%20white%20background%2C%20accessories%20visible&width=480&height=320&seq=sc-tech-3&orientation=landscape",
    interestedCount: 11, timeAgo: "1d ago",
    description: "Fly More Combo. Bought two during sale. Selling second at 38% margin.",
  },
  {
    id: "game-1",
    title: "Pokémon Scarlet Booster Bundle",
    category: "Games",
    seller: { name: "PokeProfit", initial: "P", color: "bg-amber-500" },
    buyPrice: 55, sellPrice: 110, condition: "Sealed",
    image: "https://readdy.ai/api/search-image?query=pokemon%20scarlet%20violet%20trading%20card%20game%20booster%20bundle%20sealed%20packs%20and%20box%20fanned%20out%20on%20clean%20white%20background%2C%20colorful%20card%20collecting%20product%20photography%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20background%2C%20vibrant%20packaging%20colors&width=480&height=320&seq=sc-game-1&orientation=landscape",
    interestedCount: 8, timeAgo: "3h ago",
    description: "Sealed booster bundles. Bulk bought. 100% margins on every bundle.",
  },
  {
    id: "game-2",
    title: "Zelda: TotK Collector's Edition",
    category: "Games",
    seller: { name: "NintendoNick", initial: "N", color: "bg-emerald-500" },
    buyPrice: 70, sellPrice: 135, condition: "Sealed",
    image: "https://readdy.ai/api/search-image?query=The%20Legend%20of%20Zelda%20Tears%20of%20the%20Kingdom%20collectors%20edition%20Nintendo%20Switch%20game%20box%20with%20steelbook%20on%20clean%20wooden%20surface%2C%20video%20game%20collector%20edition%20product%20photography%2C%20soft%20warm%20studio%20lighting%2C%20premium%20packaging%20detail&width=480&height=320&seq=sc-game-2&orientation=landscape",
    interestedCount: 23, timeAgo: "5h ago",
    description: "Limited run. Grabbed 3 at launch. Two sold already, last one here.",
  },
  {
    id: "game-3",
    title: "SNES Classic Mini — Sealed",
    category: "Games",
    seller: { name: "RetroRiley", initial: "R", color: "bg-violet-500" },
    buyPrice: 80, sellPrice: 175, condition: "Sealed",
    image: "https://readdy.ai/api/search-image?query=Nintendo%20SNES%20Classic%20Mini%20retro%20console%20sealed%20in%20original%20box%20on%20clean%20wooden%20surface%2C%20vintage%20retro%20gaming%20nostalgia%20collectible%20product%20photography%2C%20warm%20soft%20studio%20lighting%2C%20minimal%20clean%20background%2C%20nostalgic%20packaging%20visible&width=480&height=320&seq=sc-game-3&orientation=landscape",
    interestedCount: 16, timeAgo: "2d ago",
    description: "Pulled from storage. Sealed box, mint condition. Retro demand is at an all-time high.",
  },
  {
    id: "cloth-1",
    title: "Supreme Box Logo Hoodie — Black L",
    category: "Clothing",
    seller: { name: "SupremeSteve", initial: "S", color: "bg-red-500" },
    buyPrice: 168, sellPrice: 395, condition: "New",
    image: "https://readdy.ai/api/search-image?query=Supreme%20red%20box%20logo%20hoodie%20in%20black%20colorway%20folded%20neatly%20on%20clean%20white%20surface%2C%20premium%20streetwear%20fashion%20product%20photography%2C%20minimal%20studio%20lighting%2C%20clean%20white%20background%20showing%20iconic%20red%20Supreme%20box%20logo%20clearly&width=480&height=320&seq=sc-cloth-1&orientation=landscape",
    interestedCount: 34, timeAgo: "1h ago",
    description: "FW23 drop. Retail cop. Large is the hardest size to find — 135% margin.",
  },
  {
    id: "cloth-2",
    title: "Vintage Nike ACG Jacket — 90s",
    category: "Clothing",
    seller: { name: "VintageVince", initial: "V", color: "bg-sky-500" },
    buyPrice: 45, sellPrice: 185, condition: "Good",
    image: "https://readdy.ai/api/search-image?query=vintage%20Nike%20ACG%20mountain%20jacket%201990s%20colorful%20windbreaker%20hung%20on%20minimalist%20white%20clothing%20rack%2C%20vintage%20streetwear%20fashion%20photography%2C%20clean%20studio%20lighting%2C%20simple%20minimal%20light%20background%2C%20authentic%2090s%20sportswear%20detail&width=480&height=320&seq=sc-cloth-2&orientation=landscape",
    interestedCount: 29, timeAgo: "4h ago",
    description: "Thrift find. Size M. 90s ACG pieces are exploding right now — bought for $45.",
  },
  {
    id: "cloth-3",
    title: "Off-White Industrial Belt",
    category: "Clothing",
    seller: { name: "HypeHannah", initial: "H", color: "bg-orange-500" },
    buyPrice: 180, sellPrice: 340, condition: "Like New",
    image: "https://readdy.ai/api/search-image?query=Off-White%20industrial%20yellow%20black%20diagonal%20stripe%20logo%20belt%20on%20clean%20dark%20slate%20surface%2C%20luxury%20streetwear%20fashion%20accessory%20product%20photography%2C%20minimal%20dramatic%20studio%20lighting%2C%20clean%20dark%20minimal%20background%2C%20bold%20diagonal%20stripe%20detail%20visible&width=480&height=320&seq=sc-cloth-3&orientation=landscape",
    interestedCount: 12, timeAgo: "7h ago",
    description: "Worn once, no damage. Still sells for 2x retail all day on StockX.",
  },
  {
    id: "comp-1",
    title: "MacBook Pro M3 Pro 14\" Space Black",
    category: "Computers",
    seller: { name: "MacFlip_Tom", initial: "T", color: "bg-teal-500" },
    buyPrice: 1999, sellPrice: 2490, condition: "Sealed",
    image: "https://readdy.ai/api/search-image?query=Apple%20MacBook%20Pro%2014%20inch%20M3%20Pro%20chip%20in%20space%20black%20color%20open%20on%20clean%20minimal%20white%20desk%2C%20premium%20laptop%20product%20photography%2C%20professional%20studio%20lighting%2C%20clean%20white%20background%2C%20side%20profile%20view%20showing%20slim%20chassis%20and%20keyboard%20detail&width=480&height=320&seq=sc-comp-1&orientation=landscape",
    interestedCount: 41, timeAgo: "2h ago",
    description: "Space Black 18GB. Sold out in-store across region. Steady 25% premium.",
  },
  {
    id: "comp-2",
    title: "Apple Vision Pro 256GB",
    category: "Computers",
    seller: { name: "VisionVault", initial: "V", color: "bg-pink-500" },
    buyPrice: 3499, sellPrice: 4250, condition: "Sealed",
    image: "https://readdy.ai/api/search-image?query=Apple%20Vision%20Pro%20mixed%20reality%20spatial%20computing%20headset%20with%20light%20seal%20and%20strap%20on%20clean%20white%20surface%2C%20premium%20futuristic%20tech%20product%20photography%2C%20dramatic%20professional%20studio%20lighting%2C%20pristine%20white%20minimal%20background%2C%20front%20face%20detail&width=480&height=320&seq=sc-comp-2&orientation=landscape",
    interestedCount: 55, timeAgo: "30m ago",
    description: "Day one allocation. International buyers paying serious premiums right now.",
  },
  {
    id: "comp-3",
    title: "Steam Deck OLED 1TB",
    category: "Computers",
    seller: { name: "SteamFlip_Ray", initial: "R", color: "bg-emerald-500" },
    buyPrice: 679, sellPrice: 875, condition: "New",
    image: "https://readdy.ai/api/search-image?query=Valve%20Steam%20Deck%20OLED%20edition%201TB%20handheld%20gaming%20PC%20device%20on%20clean%20dark%20surface%2C%20gaming%20handheld%20product%20photography%2C%20dramatic%20studio%20lighting%20showing%20vivid%20OLED%20screen%20glow%2C%20minimal%20clean%20dark%20background%2C%20front%20face%20and%20controls%20visible&width=480&height=320&seq=sc-comp-3&orientation=landscape",
    interestedCount: 20, timeAgo: "9h ago",
    description: "Limited stock region. 1TB OLED model. Ships fast. 29% clean margin.",
  },
];
